import { render, staticRenderFns } from "./EditStockDlg.vue?vue&type=template&id=007b4918&scoped=true"
import script from "./EditStockDlg.vue?vue&type=script&lang=js"
export * from "./EditStockDlg.vue?vue&type=script&lang=js"
import style0 from "./EditStockDlg.vue?vue&type=style&index=0&id=007b4918&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b4918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007b4918')) {
      api.createRecord('007b4918', component.options)
    } else {
      api.reload('007b4918', component.options)
    }
    module.hot.accept("./EditStockDlg.vue?vue&type=template&id=007b4918&scoped=true", function () {
      api.rerender('007b4918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/commodity/dialog/EditStockDlg.vue"
export default component.exports